export const URL_PARAMS = {
  GOOGLE_MAPS_API_KEY: '{{googleMapsApiKey}}',
} as const;

export const GENERAL_CONFIG = {
  NOT_AVAILABLE: '-',
  DEFAULT_OFFSET: 0,
  DEFAULT_LIMIT: 10,
  DEFAULT_PERKS_CATEGORY: 'perks',
} as const;

export const MAP_CONFIG = {
  DEFAULT_ZOOM: 12,
  OFFICE_COORDINATES: {
    LAT: 51.931934000000005,
    LNG: -8.123001,
  },
} as const;

export const COMMUNICATION_CONFIG = {
  PHONE_ATTEMPTS_LIMIT: 3,
  SMS_CODE_EXPIRY_SECONDS: 600,
  PHONE_ATTEMPTS_TIME_LIMIT_IN_MINUTES: 60,
  CODE_RETRIES_LIMIT: 5,
} as const;

export const DATE_FORMATS = {
  DEFAULT: 'DD-MMM-YYYY',
} as const;

export const IMAGE_CONFIG = {
  SIZE_LIMIT_MB: 4,
  ALLOWED_IMAGE_TYPES: 'image/png, image/jpeg, image/gif',
} as const;

export const CHART_TYPES = [
  { value: 'bar', label: 'Bar' },
  { value: 'line', label: 'Line' },
  { value: 'doughnut', label: 'Doughnut' },
  { value: 'pie', label: 'Pie' },
  { value: 'polar', label: 'Polar' },
] as const;

export const CHART_OPTIONS = {
  MAINTAIN_ASPECT_RATIO: false,
  SCALES: { y: { beginAtZero: true, precision: 0 } },
  PLUGINS: {
    LEGEND: {
      DISPLAY: true,
      LABELS: {
        BOX_WIDTH: 0,
        FONT: {
          SIZE: 18,
        },
      },
    },
  },
} as const;

export const CHART_DATASET_OPTIONS = {
  BACKGROUND_COLOR: [
    'rgba(255, 99, 132, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(255, 206, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(255, 159, 64, 0.2)',
  ],
  BORDER_COLOR: [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
  ],
  BORDER_WIDTH: 1,
  BAR_THICKNESS: 30,
} as const;

export const GOOGLE_OAUTH_STATIC_URL =
  'https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?access_type=online&response_type=token&scope=email%20profile&flowName=GeneralOAuthFlow';

export const LINKEDIN_OAUTH_STATIC_URL =
  'https://www.linkedin.com/oauth/v2/authorization?response_type=code&scope=r_liteprofile%20r_emailaddress';

export const AUTH_REDIRECTS = {
  GOOGLE_AUTH_SIGNIN_CALLBACK: '/social-auth/googlesignin/callback',
  GOOGLE_AUTH_SIGNUP_CALLBACK: '/social-auth/googlesignup/callback',
  FACEBOOK_AUTH_SIGNUP_CALLBACK: '/social-auth/facebooksignup/callback',
  FACEBOOK_AUTH_SIGNIN_CALLBACK: '/social-auth/facebooksignin/callback',
  LINKEDIN_AUTH_CALLBACK: '/social-auth/linkedin/callback',
  LINKEDIN_AUTH_SIGNUP_CALLBACK: '/social-auth/linkedinsignup/callback',
  LINKEDIN_AUTH_SIGNIN_CALLBACK: '/social-auth/linkedinsignin/callback',
  GOOGLE_AUTH_CALLBACK: '/social-auth/google/callback',
  FACEBOOK_AUTH_CALLBACK: '/social-auth/facebook/callback',
  AUTH_REDIRECT_HANDLER: '/auth-redirect-handler',
  MS_AUTH_REDIRECT: '/ms-auth',
  MicrosoftTeamsConfigTab: '/microsoft-teams/channel-app/config',
} as const;

export const FACEBOOK_OAUTH_URL =
  'https://www.facebook.com/v12.0/dialog/oauth?response_type=token&scope=email';
export const TRUNCATE_TEXT_LENGTH_SMALL = 10;
export const TRUNCATE_TEXT_LENGTH_MEDIUM = 30;

// localstorage data keys names
// store the active user auth token
export const TOKEN_LOCALSTORAGE_KEY = 'pf_r32_4ui3_234';
// store admin auth token
export const ADMIN_TOKEN_LOCALSTORAGE_KEY = 'pf_r32_nhg_5t';
// store (true|false) depending on impersonation state, (true if impersonating a account)
export const IMPERSONATE_LOCALSTORAGE_KEY = 'vcx_sdf_Ge_rhb';
// store user data (encrypted object containing user data)
export const USER_LOCALSTORAGE_KEY = 'we_lk_gpf_rre_23';
// store (true|false) depending on model state, (true if showing model)
export const SHOW_MODAL_LOCALSTORAGE_KEY = 're_2we_lk_gpf_r3';
// store user token and email=true data as encrypted object
export const VERIFY_EMAIL_TOKEN_LOCALSTORAGE_KEY = 'wer_Vssdf_vf_r3';
// store (true|false) depending on page_last_refresh state, (true if page was refreshed in last call)
export const PAGE_REFRESHED_ONCE_LOCALSTORAGE_KEY = 'ds09sdf_vf_r3';
// i (ahsan) will use this key to check whether i have already tried to redirect user to mobile app when user clicks on a email login link, i will also use this keep to redirect user to mobile app when he opens the url manually in mobile browser
export const TRY_AND_REDIRECT_USER_TO_MOBILE_APP = 'dscr38g4-234-r23-4_Vd2';

// header auth keys names (should be same in backend and frontend otherwise will throw error)
// store value of 'TOKEN_LOCALSTORAGE_KEY'
export const TOKEN_HEADER_KEY = 'cus_5rge_svsb_5pf_3r';
// store a encrypted object containing value of user email from 'USER_LOCALSTORAGE_KEY' and token from 'TOKEN_LOCALSTORAGE_KEY' for API auth verification
export const USER_HEADER_KEY = 'o5r_5pf_3r4ui3_90';
// store value of 'IMPERSONATE_LOCALSTORAGE_KEY'
export const IMPERSONATE_HEADER_KEY = 'r4uo5r_5pf_3i3_90';
// store value of 'VERIFY_EMAIL_TOKEN_LOCALSTORAGE_KEY'
export const VERIFY_EMAIL_TOKEN_HEADER_KEY = 'r_5vnopf_3i3_90';
// store time info when we fetched the getUser api data last time on navigation change
export const GET_USER_API_UPDATED_AT = 'pf_3i3_9das42_30';

// url token key
// using this key in URL of manual email auth callback verification
export const TOKEN_VERIFICATION_URL_KEY = 'rb_5pf_3_3i3_90';

// Slack Bot Constants
export const SLACK_BOT = {
  SLACK_OAUTH_URL: (stateData: string, clientId: string, url: string) =>
    `https://slack.com/oauth/v2/authorize?client_id=${clientId}&scope=chat:write,chat:write.public,channels:read&redirect_uri=${url}&state=${stateData}`,
  SLACK_AUTH_REDIRECT_URL: '/slack-bot/auth-redirect',
};

export const APP_BUNDLE_ID = 'com.perkforce.app';

export const FIREBASE_RESPONSES = {
  CLOSED_BY_USER: 'auth/popup-closed-by-user',
} as const;

export const VAR_TYPES = {
  STRING: 'string',
  OBJECT: 'object',
  ARRAY: 'array',
  boolean: 'boolean',
  NUMBER: 'number',
  FUNCTION: 'function',
} as const;

export const PERKFORCE_DOMAINS = [
  'perkforce.com',
  'pfstag.com',
  'pfdevqa.com',
  'pfnew.com',
  'pfuniverse.com',
] as const;

export const TIME_UNIT_TYPE = {
  MINUTES: 'minutes',
} as const;

export const LOTTIE_ANIMATION_START_DELAY = 2000; // 2s (please provide in miliseconds)

export const APPS_STORE_LINK = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.perkforce.app',
  IOS: 'https://apps.apple.com/pk/app/perkforce/id1608229415',
};

export const DEVICE_UUID_LOCALSTORAGE_KEY = 'WFE_vwevV_sf_F-ssdfdsf_';

export const SOCKET_IO_EVENTS = {
  // frontend clients will emit these events and server will listen for them
  client: {
    perksDataChanged: 'perksDataChanged__client', // client will emit this when a manager changes perks data (by adding, updating or deleting a perk) | params { employerId } | known use case to cover, when a merchant changes his data, as he is not the employer of the users where i should clear the data
  },
  // frontend clients will listen these events and server will emit these events
  server: {
    perksDataChanged: 'perksDataChanged__server', // client will listen for this event (emitted by server, when server received 'SocketIoEvents.client.perksDataChanged' event from client)
  },
} as const;

export const URL_TARGET = {
  blank: '_blank',
} as const;

export const TOOLTIP_TRIGGER_ALL = [
  'click',
  'hover',
  'focus',
  'contextMenu',
] as const;

export const MS_TEAMS = {
  TENANT_TYPE: 'common',
  RESPONSE_TYPE: 'code',
  REQUESTED_SCOPES:
    'Channel.ReadBasic.All ChannelMessage.Send email offline_access openid profile Team.ReadBasic.All User.Read',
  GET_SERVER_AUTH_URL: (msAuthStateData: string, id: string, url: string) =>
    `https://login.microsoftonline.com/${MS_TEAMS.TENANT_TYPE}/oauth2/v2.0/authorize?client_id=${id}&response_type=${MS_TEAMS.RESPONSE_TYPE}&redirect_uri=${url}&response_mode=query&scope=${MS_TEAMS.REQUESTED_SCOPES}&state=${msAuthStateData}`,
};

export const POPOVER_TRIGGER = ['click', 'hover'] as const;

export const PERKFORCE_DETAILS = {
  supportEmail: 'support@perkforce.com',
  webAppUrl: 'https://app.perkforce.com',
  androidAppUrl:
    'https://play.google.com/store/apps/details?id=com.perkforce.app',
  iosAppUrl: 'https://apps.apple.com/pk/app/perkforce/id1608229415',
} as const;

export const TESTING_ROUTES = {
  awsV3Upload: '/testing/aws-v3-upload',
  firebaseTestingPage: '/testing/firebase',
  zustandTestingPg1: '/testing/zustand-page-1',
  zustandTestingPg2: '/testing/zustand-page-2',
  googleMapTesting: '/testing/google-map-testing',
} as const;

export const IN_APP_PUSH_NOTIFICATIONS_TOAST_KEY =
  'PERKFORCE_PUSH_NOTIFICATIONS';

export const SVG_ICON_TYPES = ['image/svg', 'image/svg+xml'] as const;
